import { faChevronDown } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isEmpty } from "lodash";
import React, { useState } from "react";
import { useDeepEffect } from "../../abstracts";
import {
  getAdvisorsList,
  getCustodiansList,
  getPlanListBasedOnFilter,
} from "../../services";
import { OPTIONS_DATA_MAPPER, toOptionValuesFromMapper } from "../../utils";
import FeeStatusDropDown from "../FeeStatusDropDown";
import Link from "../Link";

const FeeApplicableToFilterCard = ({
  addedPlanGroups,
  setPlanListFilter,
  setFilteredPlans,
  addedPlans,
  investmentInformation,
}) => {
  const [tags, setTags] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedPlanTypes, setSelectedPlanTypes] = useState([]);
  const [selectedAdvisor, setSelectedAdvisor] = useState([]);
  const [selectedClearingPartner, setSelectedClearingPartner] = useState([]);
  const [selectedCount, setSelectedCount] = useState([]);
  const [advisorList, setAdvisorList] = useState([]);
  const [clearingPartnerList, setClearingPartnerList] = useState([]);

  const planTypes = toOptionValuesFromMapper(OPTIONS_DATA_MAPPER.PLAN_TYPES);
  const statusList = toOptionValuesFromMapper(
    OPTIONS_DATA_MAPPER.PLAN_STATUS_LIST_0
  );
  const [transformedValues, setTransformedValues] = useState(statusList);
  const [
    transformedValuesForPlanType,
    setTransformedValuesForPlanType,
  ] = useState(planTypes);
  const planGroup = addedPlanGroups?.map((_) => _.planGroupId);

  useDeepEffect(() => {
    getAdvisorsList().then((response) => {
      setAdvisorList(
        !isEmpty(response) &&
          response.map((val, ind) => ({
            label: val.name,
            value: val.id,
          }))
      );
      setTransformedValuesForAdvisor(advisorList);
    });
    getCustodiansList().then((response) => {
      setClearingPartnerList(
        !isEmpty(response) &&
          response.map((val, ind) => ({
            label: val.name,
            value: val.id,
          }))
      );
    });
  }, []);

  const [
    transformedValuesForAdvisor,
    setTransformedValuesForAdvisor,
  ] = useState(advisorList);
  const [
    transformedValuesForClearingPartner,
    setTransformedValuesForClearingPartner,
  ] = useState(clearingPartnerList);

  useDeepEffect(() => {
    if (!isEmpty(advisorList)) {
      setTransformedValuesForAdvisor(advisorList);
    }
    if (!isEmpty(clearingPartnerList)) {
      setTransformedValuesForClearingPartner(clearingPartnerList);
    }
  }, [advisorList, clearingPartnerList]);

  const clearFilterValues = () => {
    setSelectedPlanTypes([]);
    setSelectedStatus([]);
    setSelectedAdvisor([]);
    setSelectedClearingPartner([]);
    setTags([]);
    setTransformedValues(
      transformedValues.map((item) => {
        return { ...item, checked: false };
      })
    );
    setTransformedValuesForPlanType(
      transformedValuesForPlanType.map((item) => {
        return { ...item, checked: false };
      })
    );
    setTransformedValuesForAdvisor(
      transformedValuesForAdvisor.map((item) => {
        return { ...item, checked: false };
      })
    );
    setTransformedValuesForClearingPartner(
      transformedValuesForClearingPartner.map((item) => {
        return { ...item, checked: false };
      })
    );
    getPlanListBasedOnFilter({
      planType: [],
      statusType: [],
      advisor: [],
      clearingPartner: [],
      planGroup: isEmpty(planGroup) ? [] : planGroup,
      investment: investmentInformation?.id,
    }).then((response) => {
      let temp = response;
      if (!isEmpty(addedPlans)) {
        temp = response.filter(
          (plan) => !addedPlans.map((item) => item.planId).includes(plan.planId)
        );
      }
      setFilteredPlans(temp);
      setPlanListFilter(temp);
    });
  };

  const onDeleteFilterClick = (index, itemIndex) => {
    let data = tags[index][0].filter((item) => item.value !== itemIndex);
    setTags({ ...tags, [index]: [data] });
    let ids = data.map((id) => id.value);
    let status = transformedValues.map((itm, i) => {
      if (i === itemIndex) return (itm = { ...itm, checked: false });
      else return itm;
    });
    let plantype = transformedValuesForPlanType.map((itm, i) => {
      if (itm.value === itemIndex) return (itm = { ...itm, checked: false });
      else return itm;
    });
    let advisor = transformedValuesForAdvisor.map((itm, i) => {
      if (itm.value === itemIndex) return (itm = { ...itm, checked: false });
      else return itm;
    });
    let clearingPartner = transformedValuesForClearingPartner.map((itm, i) => {
      if (itm.value === itemIndex) return (itm = { ...itm, checked: false });
      else return itm;
    });
    switch (index) {
      case 1:
        setSelectedStatus(ids);
        setTransformedValues(status);
        break;
      case 2:
        setSelectedPlanTypes(ids);
        setTransformedValuesForPlanType(plantype);
        break;
      case 3:
        setSelectedAdvisor(ids);
        setTransformedValuesForAdvisor(advisor);
        break;
      case 4:
        setSelectedClearingPartner(ids);
        setTransformedValuesForClearingPartner(clearingPartner);
        break;
      default:
        break;
    }
  };

  const filters = [statusList, planTypes, advisorList, clearingPartnerList];

  const handleFilters = (list, values) => {
    let data = filters[list - 1].filter((item) =>
      values.map((x) => x).includes(item.value)
    );
    setTags({ ...tags, [list]: [data] });
  };

  const hideTags = () => {
    let x = document.getElementsByClassName("tags-filter");
    let y = x[0].style.display;
    if (y === "none") {
      x[0].style.display = "block";
    } else {
      x[0].style.display = "none";
    }
  };

  useDeepEffect(() => {
    setSelectedCount(0);

    if (!isEmpty(tags)) {
      setSelectedCount(0);
      let arr = [];
      [1, 2, 3, 4, 5, 6, 7].map((filterIndex) => {
        (tags[filterIndex] || []).map((data, index) =>
          data.map((item, idx) => arr.push(item.label))
        );
      });
      setSelectedCount(arr.length);
    } else {
      setSelectedCount(0);
    }
  }, [tags]);

  const onClearOptions = (x) => {
    switch (x) {
      case 1:
        setSelectedStatus([]);
        handleFilters(1, []);
        setTransformedValues(
          transformedValues.map((item) => {
            return { ...item, checked: false };
          })
        );
        break;
      case 2:
        setSelectedPlanTypes([]);
        handleFilters(2, []);
        setTransformedValuesForPlanType(
          transformedValuesForPlanType.map((item) => {
            return { ...item, checked: false };
          })
        );
        break;
      case 3:
        setSelectedAdvisor([]);
        handleFilters(3, []);
        setTransformedValuesForAdvisor(
          transformedValuesForAdvisor.map((item) => {
            return { ...item, checked: false };
          })
        );
        break;
      case 4:
        setSelectedClearingPartner([]);
        handleFilters(4, []);
        setTransformedValuesForClearingPartner(
          transformedValuesForClearingPartner.map((item) => {
            return { ...item, checked: false };
          })
        );
        break;
      default:
        break;
    }
  };

  const applyFiltersClick = () => {
    getPlanListBasedOnFilter({
      planType: selectedPlanTypes,
      statusType: selectedStatus,
      advisor: selectedAdvisor,
      clearingPartner: selectedClearingPartner,
      planGroup: isEmpty(planGroup) ? [] : planGroup,
      investment: investmentInformation?.id,
    }).then((response) => {
      let temp = response;
      if (!isEmpty(addedPlans)) {
        temp = response.filter(
          (plan) => !addedPlans.map((item) => item.planId).includes(plan.planId)
        );
      }
      setFilteredPlans(temp);
      setPlanListFilter(temp);
    });
  };

  const hideStatusTag = () => {
    let x = document.getElementsByClassName("statustags-filter");
    let y = x[0].style.display;
    if (y === "none") {
      x[0].style.display = "block";
    } else {
      x[0].style.display = "none";
    }
  };

  const hidePlanTypeTag = () => {
    let x = document.getElementsByClassName("planTypetags-filter");
    let y = x[0].style.display;
    if (y === "none") {
      x[0].style.display = "block";
    } else {
      x[0].style.display = "none";
    }
  };

  const hideAdvisorTag = () => {
    let x = document.getElementsByClassName("advisortags-filter");
    let y = x[0].style.display;
    if (y === "none") {
      x[0].style.display = "block";
    } else {
      x[0].style.display = "none";
    }
  };

  const hideClearingPartnerTag = () => {
    let x = document.getElementsByClassName("clearingPartnertags-filter");
    let y = x[0].style.display;
    if (y === "none") {
      x[0].style.display = "block";
    } else {
      x[0].style.display = "none";
    }
  };

  return (
    <div className="col1-fees">
      <div className="left-header d-flex justify-content-space-between">
        <div className="planTitle">Filters</div>
        <div>
          {selectedCount} Selected
          <Link
            className="feesPlanGroupApply"
            onClick={() => applyFiltersClick()}
          >
            Apply
          </Link>
        </div>
      </div>

      <div className="filtersCount d-flex flexD-col">
        <div className="d-flex justify-content-space-between">
          <div>Filters applied</div>
          <div className="Arrow-up">
            <Link onClick={() => clearFilterValues()}>Clear all</Link>
            <Link onClick={hideTags} className="pl-3">
              <FontAwesomeIcon icon={faChevronDown} />
            </Link>
          </div>
        </div>
        <div className="tags-filter" style={{ display: "none" }}>
          <div>
            <div className="filterTags marg-top-5 pad-top-15">
              {[1, 2, 3, 4, 5, 6, 7].map((filterIndex) => {
                return (tags[filterIndex] || []).map((data, index) =>
                  data.map((item, idx) => (
                    <div className="flex-start">
                      <div className="tags-fee">
                        <div className="filter-text-fee">{item.label}</div>
                        <div className="filter-cross-icon-fee">
                          <Link
                            onClick={() =>
                              onDeleteFilterClick(filterIndex, item.value)
                            }
                          >
                            <i
                              class="fa fa-times-circle"
                              aria-hidden="true"
                            ></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div className="filtersFees">
        <div className="d-flex justify-content-space-between">
          <div>Plan Status</div>
          <div className="Arrow-up">
            <Link onClick={() => onClearOptions(1)}>Clear all</Link>
          </div>
        </div>
        <div className="status-Pop">
          <div className="d-flex justify-content-space-between">
            <div> {selectedStatus.length} Selected</div>
            <Link onClick={hideStatusTag}>
              <FontAwesomeIcon icon={faChevronDown} />
            </Link>
          </div>
          <div className="statustags-filter" style={{ display: "none" }}>
            <hr className="margin-0"></hr>
            <FeeStatusDropDown
              hideSelectedOptions="FALSE"
              width="96%"
              height={statusList.length * 30}
              maxHeight="238px"
              transformedValues={transformedValues}
              setTransformedValues={setTransformedValues}
              onSelect={(value) => {
                setSelectedStatus(value);
                handleFilters(1, value);
              }}
              name={"statusList"}
              value={selectedStatus}
            />
          </div>
        </div>

        <div className="d-flex justify-content-space-between">
          <div>Plan Type</div>
          <div className="Arrow-up">
            <Link onClick={() => onClearOptions(2)}>Clear all</Link>
          </div>
        </div>
        <div className="status-Pop">
          <div className="d-flex justify-content-space-between">
            <div> {selectedPlanTypes.length} Selected</div>
            <Link onClick={hidePlanTypeTag}>
              <FontAwesomeIcon icon={faChevronDown} />
            </Link>
          </div>
          <div className="planTypetags-filter" style={{ display: "none" }}>
            <hr className="margin-0"></hr>
            <FeeStatusDropDown
              hideSelectedOptions="FALSE"
              width="96%"
              height={planTypes.length * 30}
              maxHeight="238px"
              transformedValues={transformedValuesForPlanType}
              setTransformedValues={setTransformedValuesForPlanType}
              onSelect={(value) => {
                setSelectedPlanTypes(value);
                handleFilters(2, value);
              }}
              name={"planTypes"}
              value={selectedPlanTypes}
            />
          </div>
        </div>

        <div className="d-flex justify-content-space-between">
          <div>Advisor</div>
          <div className="Arrow-up">
            <Link onClick={() => onClearOptions(3)}>Clear all</Link>
          </div>
        </div>
        <div className="status-Pop">
          <div className="d-flex justify-content-space-between">
            <div> {selectedAdvisor.length} Selected</div>
            <Link onClick={hideAdvisorTag}>
              <FontAwesomeIcon icon={faChevronDown} />
            </Link>
          </div>
          <div className="advisortags-filter" style={{ display: "none" }}>
            <hr className="margin-0"></hr>
            <FeeStatusDropDown
              hideSelectedOptions="FALSE"
              width="96%"
              height={advisorList.length * 30}
              maxHeight="238px"
              transformedValues={transformedValuesForAdvisor}
              setTransformedValues={setTransformedValuesForAdvisor}
              onSelect={(value) => {
                setSelectedAdvisor(value);
                handleFilters(3, value);
              }}
              name={"advisorList"}
              value={selectedAdvisor}
            />
          </div>
        </div>

        <div className="d-flex justify-content-space-between">
          <div>Clearing Partner</div>
          <div className="Arrow-up">
            <Link onClick={() => onClearOptions(4)}>Clear all</Link>
          </div>
        </div>
        <div className="status-Pop">
          <div className="d-flex justify-content-space-between">
            <div> {selectedClearingPartner.length} Selected</div>
            <Link onClick={hideClearingPartnerTag}>
              <FontAwesomeIcon icon={faChevronDown} />
            </Link>
          </div>
          <div
            className="clearingPartnertags-filter"
            style={{ display: "none" }}
          >
            <hr className="margin-0"></hr>
            <FeeStatusDropDown
              hideSelectedOptions="FALSE"
              width="96%"
              height={clearingPartnerList.length * 30}
              maxHeight="238px"
              transformedValues={transformedValuesForClearingPartner}
              setTransformedValues={setTransformedValuesForClearingPartner}
              onSelect={(value) => {
                setSelectedClearingPartner(value);
                handleFilters(4, value);
              }}
              name={"clearingPartnerList"}
              value={selectedClearingPartner}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeeApplicableToFilterCard;
